import { useAppDispatch } from "@hook/useAppDispatch"
import { useAppSelector } from "@hook/useAppSelector"
import { resetDataTelesalesGroups } from "@reducer/version2/product-detail"
import { callAddGroupToCombo } from "@reducer/version2/skuCombo-detail.reducer"
import { callGetTelesalesGroupsSuggest } from "@reducer/version2/telesales-group.reducer"
import { trans } from "@resources/localization"
import { AutoComplete, Button, Col, Empty, Form, message, Row, Space, Spin } from "antd"
import { debounce, find } from "lodash"
import React, { useEffect, useMemo } from "react"
import { useParams } from "react-router-dom"

type Props = {
    setClose: () => void
}
export const AddGroup: React.FC<Props> = ({ setClose }) => {
    const { id } = useParams()
    const [formRef] = Form.useForm()
    const dispatch = useAppDispatch()
    const groupsTelesalesSuggest = useAppSelector((state) => state.telesalesGroup.telesalesGroupsSuggest)
    const loadingListGroupSuggest = useAppSelector((state) => state.telesalesGroup.loadingListGroupSuggest)
    const groupsOfCombo = useAppSelector((state) => state.skuComboDetail.groupsOfCombo)
    const loadingAdd = useAppSelector((state) => state.productDetail.loadingAddGroups)

    useEffect(() => {
        dispatch(callGetTelesalesGroupsSuggest({ query: "" }))
    }, [dispatch])

    const options = useMemo(
        () =>
            groupsTelesalesSuggest?.map((item) => ({
                value: item?.name,
                key: item?.code,
            })),
        [groupsTelesalesSuggest]
    ).filter((el) => !find(groupsOfCombo, { groupCode: el.key }))

    const onSearchGroupsTelesales = (searchText: string) => {
        if (searchText.trim().length >= 3) {
            dispatch(callGetTelesalesGroupsSuggest({ query: searchText?.trim() }))
        } else {
            dispatch(callGetTelesalesGroupsSuggest({ query: "" }))
        }
    }

    const addGroupIntoProduct = (values: { groupCodes: string }) => {
        dispatch(
            callAddGroupToCombo({
                code: id || "",
                body: {
                    groupCodes: [values.groupCodes],
                },
            })
        ).then((result: any) => {
            if (result?.payload?.status === 200) {
                message.success(trans("message.success"))
                formRef.resetFields()
                setClose()
            } else {
                message.error(result?.payload?.response?.data?.message || trans("message.fail"))
            }
        })
    }
    return (
        <div className="w-72">
            <Form
                form={formRef}
                layout="vertical"
                onFinish={addGroupIntoProduct}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            name="groupCodes"
                            hidden></Form.Item>
                        <Form.Item
                            label={trans("products.group_name")}
                            name="groupName"
                            rules={[{ required: true, message: trans("message.required") }]}>
                            <AutoComplete
                                notFoundContent={loadingListGroupSuggest ? <Spin /> : <Empty />}
                                allowClear
                                onSearch={debounce(onSearchGroupsTelesales, 1000)}
                                placeholder={trans("products.group_name")}
                                options={options}
                                onSelect={(val: any, option: any) => {
                                    formRef.setFieldsValue({
                                        groupCodes: option?.key,
                                    })
                                }}
                                onBlur={() => {
                                    if (!formRef.getFieldValue("groupCodes")) {
                                        formRef.setFieldsValue({
                                            groupName: "",
                                        })
                                        dispatch(resetDataTelesalesGroups([]))
                                    }
                                }}
                                onKeyDown={(e) => (e.keyCode == 13 ? e.preventDefault() : "")}
                            />
                        </Form.Item>
                    </Col>
                </Row>
                <Row justify="end">
                    <Space>
                        <Button
                            type="default"
                            loading={loadingAdd}
                            onClick={() => {
                                formRef.resetFields()
                                setClose()
                            }}>
                            {trans("button.cancel")}
                        </Button>
                        <Button
                            type="primary"
                            loading={loadingAdd}
                            htmlType="submit"
                            className="ml-2">
                            {trans("button.add")}
                        </Button>
                    </Space>
                </Row>
            </Form>
        </div>
    )
}
